import React from "react";
import PremiumTheme from "../Billing/PremiumTheme";

const ThemeComponentPremium = ({
  updateTheme,
  themeClass,
  themeName,
  themeFontColor,
  account,
  pageDetails,
  setShowUpgradeModal,
  themePreview,
}) => {
  return (
    <div
      className="theme"
      onClick={
        account.IsPaying
          ? () => {
              themeClass === "perso"
                ? updateTheme("none")
                : updateTheme(themeClass, themeFontColor);
            }
          : () => {
              setShowUpgradeModal(true);
            }
      }
    >
      <div
        className={`${
          !pageDetails.HasCustomTheme && pageDetails.ThemeClass === themeClass
            ? `theme-style selected`
            : `theme-style`
        }`}
      >
        {" "}
        <img
          src={themePreview}
          alt="theme preview"
          className="theme-preview"
        />{" "}
        {!account.IsPaying ? (
          <div className="premium-theme">
            <PremiumTheme fontSize="12px" height="30px" />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="theme-name">{themeName}</div>
    </div>
  );
};

export default ThemeComponentPremium;
